import React from 'react'
import { Dropdown } from 'react-bootstrap'
import moment from 'moment'
import useCurrentUser from '../../../hooks/use-current-user'
import useClientLocation from '../../../hooks/use-client-location'
import CLIENT_ROUTES from '../../../constants/client-endpoints'

const ExperiencesDuplicateMenu = ({
    experience = {},
}) => {
    const { isAdmin, isFacilitator } = useCurrentUser()
    const { toLocation } = useClientLocation()
    const url = `${CLIENT_ROUTES.EXPERIENCE.replace(':experienceId', experience.id)}${CLIENT_ROUTES.DUPLICATE}`

    return (
        <Dropdown.Item
            onClick={() => toLocation(url)}
            disabled={!isAdmin && !isFacilitator}
        >
            Duplicate
        </Dropdown.Item>
    )
}

export default ExperiencesDuplicateMenu